/*
* Project: LegalPlace assistant
* File: src/redux/reducers/checkout_operations.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import {
  BUILD_CHECKOUT,
  UPDATE_CSRF,
  CK_UPDATE_PROMOTION,
  CK_SET_PACK,
  CK_TOGGLE_CALL,
  CK_TOGGLE_LETTER,
  CK_UPDATE_ADDRESS,
  CK_UPDATE_CITY,
  CK_UPDATE_LETTER_NUMBER,
  CK_UPDATE_NAME,
  CK_UPDATE_ZIP,
  CK_UPDATE_PAYMENT_METHOD,
  CK_UPDATE_C_NUMBER,
  CK_UPDATE_C_EXPIRATION,
  CK_UPDATE_C_CCV,
  CK_UPDATE_DIRECT_NAME,
  CK_UPDATE_IBAN,
  CK_M_CREDIT_CARD,
  CK_CHECK,
  CK_UPDATE_REDUCTION,
  CK_LOADING_REDUCTION,
  CE_TOGGLE_PACK,
  PACK_ENTREPRENEUR_HEADER_BTN,
  PACK_ENTREPRENEUR_CHOOSE_PACK,
  PACK_ENTREPRENEUR_ADD_UPSELL,
  IU_NAME,
  IU_ADDRESS,
  IU_CITY,
  IU_ZIP,
  IU_TVA,
  IU_VIS,
} from '../actions/checkout_operations';

// definition of some consts

export default function checkoutReducer(state = {
  user_id: '',
  contract_id: '',
  prices: {},
  admin_fees: {},
  pricing_type: '',
  dis_link: '',
  ml_link: '',
  csrf_key: '',
  csrf_value: '',
  c_codes: {},
  has_call: false,
  has_letter: false,
  promo_code: '',
  promo_percentage: 0,
  promo_loading: false,
  letter: {
    number: 1,
    name: '',
    address: '',
    city: '',
    zip: '',
  },
  pack: 1,
  payment_method: 0,
  credit_card: {
    expiration: "",
    number: "",
    ccv: ""
  },
  direct_name: "",
  direct_iban: "",
  confirm: false,
  show_payment_modal: false,
  togglepack: undefined,
  toggle_invoice: false,
  invoice: {
    organization: '',
    address: '',
    city: '',
    zip_code: '',
    nb_tva: '',
  },
  packEntrepreneur: {
    backHeaderBtn: false,
    choosePack: undefined,
    upsellArray: []
  }
}, action) {
  let result = Object.assign({}, state);
  switch (action.type) {
    case BUILD_CHECKOUT:

      result = Object.assign(result, {
        user_id: action.user_id,
        contract_id: action.contract_id,
        contract_meta_id: action.contract_meta_id,
        prices: action.prices,
        admin_fees: action.admin_fees,
        pricing_type: action.pricing_type,
        detailsCheckout: action.detailsCheckout,
        dis_link: action.desabonnement,
        ml_link: action.ml_link,
        c_codes: action.c_codes,
      });
      return result;
    case UPDATE_CSRF:
      result.csrf_key = action.csrf.tokenKey;
      result.csrf_value = action.csrf.token;
      return result;
    case CK_UPDATE_PROMOTION:
      result.promo_code = action.val;
      return result;
    case CK_SET_PACK:
      result.pack = action.val;
      return result;
    case CK_TOGGLE_CALL:
      result.has_call = action.val;
      return result;
    case CK_TOGGLE_LETTER:
      result.has_letter = action.val;
      return result;
    case CK_UPDATE_LETTER_NUMBER:
      result.letter.number = action.incr;
      return result;
    case CK_UPDATE_NAME:
      result.letter.name = action.val;
      return result;
    case CK_UPDATE_CITY:
      result.letter.city = action.val;
      return result;
    case CK_UPDATE_ADDRESS:
      result.letter.address = action.val;
      return result;
    case CK_UPDATE_ZIP:
      result.letter.zip = action.val;
      return result;
    case CK_UPDATE_PAYMENT_METHOD:
      result.payment_method = action.method;
      return result;
    case CK_UPDATE_C_NUMBER:
      result.credit_card.number = action.val;
      return result;
    case CK_UPDATE_C_EXPIRATION:
      result.credit_card.expiration = action.val;
      return result;
    case CK_UPDATE_C_CCV:
      result.credit_card.ccv = action.val;
      return result;
    case CK_UPDATE_DIRECT_NAME:
      result.direct_name = action.val;
      return result;
    case CK_UPDATE_IBAN:
      result.direct_iban = action.val;
      return result;
    case CK_CHECK:
      result.confirm = action.val;
      return result;
    case 'UPDATE_C_CODES':
      result.c_codes = action.c_codes;
      return result;
    case CK_UPDATE_REDUCTION:
      result.promo_percentage = action.reduction;
      return result;
    case CK_LOADING_REDUCTION:
      result.promo_loading = action.val;
      return result;
    case CE_TOGGLE_PACK:
      result.togglepack = action.val;
      return result;
    case PACK_ENTREPRENEUR_HEADER_BTN:
      result.packEntrepreneur.backHeaderBtn = action.val;
      return result;
    case PACK_ENTREPRENEUR_CHOOSE_PACK:
      result.packEntrepreneur.choosePack = action.val;
      return result;
    case PACK_ENTREPRENEUR_ADD_UPSELL:
      result.packEntrepreneur.upsellArray = action.val;
      return result; 
    case IU_NAME:
      result.invoice.organization = action.val;
      return result;
    case IU_ADDRESS:
      result.invoice.address = action.val;
      return result;
    case IU_CITY:
      result.invoice.city = action.val;
      return result;
    case IU_ZIP:
      result.invoice.zip_code = action.val;
      return result;
    case IU_TVA:
      result.invoice.nb_tva = action.val;
      return result;
    case IU_VIS:
      result.toggle_invoice = !result.toggle_invoice;
      return result;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/checkout_operations.js